import script from "./FadeTransitionGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./FadeTransitionGroup.vue?vue&type=script&setup=true&lang=js"

import "./FadeTransitionGroup.vue?vue&type=style&index=0&id=81dca982&lang=css"

const __exports__ = script;

export default __exports__